import Vue from 'vue'
import moment from 'moment'
import { log } from 'async'
var momentDurationFormatSetup = require("moment-duration-format");
momentDurationFormatSetup(moment);
//Render filter
Vue.filter('formatSize', function (size) {
  if (size === undefined || size === null || size === '') {
    return 'None'
  } else if (size >= 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2).toLocaleString('en-US') + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2).toLocaleString('en-US') + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2).toLocaleString('en-US') + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2).toLocaleString('en-US') + ' KB'
  }
  return size.toString() + ' B'
})

Vue.filter('numberFormatSpaceSperator', value => {
  var x = Number(value).toFixed(2);
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\.0+$/,'');
})


Vue.filter('DateTime', value => {
  if (!value) value = new Date();
  return moment(value).format('MMM DD YYYY HH:mm:ss');//.format('MM/DD/YYYY HH:mm')
})

Vue.filter('simplyDate', value => {
  if (!value) value = new Date()
  return moment.utc(value).local().format('MMM DD YYYY')
})

Vue.filter('totalMinute', value => {
  if (!value) value = '00:00:00';
  var hms = value;   // your input string
  var a = hms.split(':'); // split it at the colons

  // Hours are worth 60 minutes.
  var minutes = (+a[0]) * 60 + (+a[1]);

  return minutes;
})

Vue.filter('roundedMoney', value => {
  if (!value) return "-- -- -- --";
  return Math.round(value * 10000) / 10000;
})

Vue.filter('sumMoneyTask', value => {
  if (!value) return "-- -- -- --";
  let valSum = value.reduce((total, frameIt) => {
    return total + frameIt.totalCharges;
  }, 0);
  return Math.round(valSum * 10000) / 10000;
})

Vue.filter('sumDurationTask', durations => {
  if (!durations) return "-- -- -- --";
  let totalDurations = durations
    .reduce((prev, cur) => {
      return moment.duration(cur.renTimeStampTimeStampStr).add(prev);
    }, moment.duration('00:00:00'));
  let durationFormat = `${(totalDurations._data.hours > 0 ? 'HH[h]' : '')}`;
  durationFormat += `${(totalDurations._data.minutes > 0 ? 'mm[m]' : '')}`;
  durationFormat += `${(totalDurations._data.seconds > 0 ? 'ss[s]' : 's[s]')}`;
  return moment.utc(totalDurations.asMilliseconds()).format(durationFormat);
})

Vue.filter('hourDuration', durations => {
  if (!durations) return "-- -- -- --";
  let totalDurations = moment.duration(parseFloat(durations), 'hours');
  let durationFormat = `${(totalDurations._data.hours > 0 ? 'H[h]' : '')}`;
  durationFormat += `${(totalDurations._data.minutes > 0 ? 'm[m]' : '')}`;
  durationFormat += `${(totalDurations._data.seconds > 0 ? 's[s]' : 's[s]')}`;
  return moment.utc(totalDurations.asMilliseconds()).format(durationFormat);
})

Vue.filter('durationIrFormat', durations => {
  if (!durations) return "-- -- -- --";
  let durationsVal = moment.duration(durations);
  let durationFormat = `${(durationsVal._data.hours > 0 ? 'HH[h]' : '')}`;
  durationFormat += `${(durationsVal._data.minutes > 0 ? 'mm[m]' : '')}`;
  durationFormat += `${(durationsVal._data.seconds > 0 ? 'ss' : 's')}`;
  durationFormat += `${(durationsVal._data.milliseconds > 0 ? '[.]SSS[s]' : '[s]')}`;
  return moment.utc(durationsVal.asMilliseconds()).format(durationFormat);
})

Vue.filter('getFileExtension', value => {
  return (/[.]/.exec(value)) ? /[^.]+$/.exec(value)[0] : undefined;
})

Vue.filter('pretyDate', value => {
  if (!value) value = new Date()
  return moment(value).calendar(null, {
    sameDay: '[Today] hh:mm A',
    lastDay: '[Yesterday] hh:mm A',
    lastWeek: 'MMM DD YYYY hh:mm A',
    sameElse: 'MMM DD YYYY hh:mm A',
  });
})

Vue.filter('dateUtcToLocalFromNow', value => {
  if (!value) value = new Date();
  var offset = new Date().getTimezoneOffset();
  var localVal = moment(value).add(-offset, 'minutes');
  return moment(localVal).fromNow();
})

Vue.filter('pretyDateUtcToLocal', value => {
  if (!value) value = new Date();
  var offset = new Date().getTimezoneOffset();
  var localVal = moment(value).add(-offset, 'minutes');
  return moment(localVal).calendar(null, {
    sameDay: '[Today] hh:mm A',
    lastDay: '[Yesterday] hh:mm A',
    lastWeek: 'MMM DD YYYY hh:mm A',
    sameElse: 'MMM DD YYYY hh:mm A',
  });
})

Vue.filter('datePretyUtcToLocal', value => {
  if (!value) value = new Date();
  var offset = new Date().getTimezoneOffset();
  var localVal = moment(value).add(-offset, 'minutes');
  return moment(localVal).format("dddd, MMMM Do YYYY, h:mm:ss a")
})

Vue.filter('stringTonumber', value => {
  if (!value) value = '-';
  return parseFloat(value);
})

Vue.filter('dateFullPrety', value => {
  if (!value) value = new Date()
  return moment(value).format("dddd, MMMM Do YYYY, h:mm:ss a")
})

Vue.filter('dateFull', value => {
  if (!value) value = new Date()
  return moment.utc(value).local().format('MMM DD YYYY HH:mm:ss')
})

Vue.filter('gender', value => {
  switch (value) {
    case 1:
      return 'Male';
    case 2:
      return 'Female';
    case 3:
      return 'Other';
    default:
      return null;
  }
})

Vue.filter('secondDuration', durations => {
  if (!durations) return "-- -- -- --";
  if (durations === 0) return "0s";
  let totalDurations = moment.duration(parseFloat(durations), 'seconds');
  console.log('totalDurations', totalDurations);
  let durationFormat = `${(totalDurations._data.days > 0 ? 'D[d]' : '')}`;
  durationFormat += `${(totalDurations._data.hours > 0 ? 'H[h]' : '')}`;
  durationFormat += `${(totalDurations._data.minutes > 0 ? 'm[m]' : '')}`;
  durationFormat += `${(totalDurations._data.seconds > 0 ? 's[s]' : 's[s]')}`;
  return totalDurations.format(durationFormat);
})

Vue.directive('numericOnly', {
  bind(el) {
    el.addEventListener('keyup', () => {
      console.log(el.value)
      let regex = /^[0-9]*$/
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1)
      }
    })
  }
})